import e from "../managers/braze-instance.js";
import vt from "./utils/push-utils.js";
export function isPushBlocked() {
  if (e.rr()) return vt.isPushBlocked();
}
